import axios from 'axios'
import {toData} from "./util";

export function remove(id): Promise {
  return axios.delete(`/api/locations/${id}`).then(toData)
}

export function upsert(location, subsidiaryId): Promise {
  return axios.post(`/api/locations?subsidiaryId=${subsidiaryId}`, location).then(toData)
}
